// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8d64a25c","845":"72690e52"}[chunkId] + ".chunk.js";
};